import axiosClient from '../api/axiosClient';
import API from '../Constants/apiRoutes';

const adminUserService = {
  /** GET /admin/users -> Administration user list (PlatformAdmin). */
  getUsers: async () => {
    const { data } = await axiosClient.get(API.users.list);
    return data;
  },

  /** POST /admin/users -> create a PlatformAdmin / CIO / CFO / Support account. */
  createUser: async (payload) => {
    const { data } = await axiosClient.post(API.users.create, payload);
    return data;
  },

  /** PATCH /admin/users/{id}/status -> activate or deactivate an account. */
  setStatus: async (id, isActive) => {
    const { data } = await axiosClient.patch(API.users.status(id), { isActive });
    return data;
  },
};

export default adminUserService;
